import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole, isInsuracePortalUser } from 'globalutils/fmUtils';

const getProviderCheck = ({ provider }) => {
  return {
    roadsideInspection: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => !isInsuracePortalUser(),
    },
    middleWrapper: {
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      default: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
    },
    fetchVehicleRadius: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => [SERVICE_PROVIDERS.RISK_THEORY].includes(provider),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
